'use client';

import React from 'react';
import { Button, Icons, Box } from '@shared/ui';

interface GridEditButtonProps {
    id: string;
}

export const GridEditButton: React.FC<GridEditButtonProps> = ({ id }) => {
    return (
        <Button
            data-edit-button-id={id}
            inline
            pointerEvents="auto"
            variant="secondary"
            isFullWidth
            sx={{
                position: 'absolute',
                bottom: '14px',
                left: '14px',
                maxWidth: '32px !important',
                height: '32px !important',
                borderRadius: 'full',
                color: 'dynamic.040',
                bg: 'neutral.000',
                zIndex: 999,
            }}
        >
            <Box pointerEvents="none">
                <Icons.csr.Pencil size="20px" weight="bold" />
            </Box>
        </Button>
    );
};
